import { render, staticRenderFns } from "./CommitteesList.vue?vue&type=template&id=e48e6110"
import script from "./CommitteesList.vue?vue&type=script&lang=js"
export * from "./CommitteesList.vue?vue&type=script&lang=js"
import style0 from "./CommitteesList.vue?vue&type=style&index=0&id=e48e6110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports